import { InjectionToken } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ObjectType } from '@vendasta/auxiliary-data-components';
import { BehaviorSubject } from 'rxjs';

export const SELECTED_OBJECT_TYPE$$ = new InjectionToken<BehaviorSubject<ObjectType>>('SELECTED_OBJECT_TYPE');

export const VIEWING_ARCHIVED$$ = new InjectionToken<BehaviorSubject<boolean>>('VIEWING_ARCHIVED');
